/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

import { SmartLinesDiffComputer } from './smartLinesDiffComputer';
import { StandardLinesDiffComputer } from './standardLinesDiffComputer';

export const linesDiffComputers = {
	smart: new SmartLinesDiffComputer(),
	experimental: new StandardLinesDiffComputer(),
};
